import styled from 'styled-components';
import { List as ListAntd } from 'antd';
import thumbStyle from '../../configs/thumbStyle';

const List = styled(ListAntd)`
  overflow-y: auto;
  overflow-x: hidden;
  ${thumbStyle};
  max-height: ${(props) => {
    return props.maxheight ? `${props.maxheight}px` : 'unset';
  }};
`;

export default List;
